import React from "react";
import { COMPANY, CONTACT_PAGE } from "../../content/siteContent";
import { ContactNumbers } from "../ContactNumbers/ContactNumbers";

export const ContactQuickDetails = () => {
  return (
    <section className="faq-area pt-120 pb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="faq-content">
              <div className="section-title mb-30 text-center">
                <span className="sub-title">Quick Contact</span>
                <h2 className="title">Reach Zawix directly</h2>
                <p>{CONTACT_PAGE.prompt}</p>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="contact-info-item">
                    <h5 className="title-two">Phone / WhatsApp</h5>
                    <ContactNumbers />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="contact-info-item">
                    <h5 className="title-two">Call Numbers</h5>
                    <ContactNumbers includeWhatsApp={false} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="contact-info-item">
                    <h5 className="title-two">Email</h5>
                    <ul className="list-wrap">
                      <li>{COMPANY.email}</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center">
                <p>{CONTACT_PAGE.consultation}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
